import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class ModemService extends HeaderService {
    getModemsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getModemsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createModem(Modem: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'modem/',
            JSON.stringify(Modem),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateModem(Modem: any, id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'modem/' + id,
            JSON.stringify(Modem),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getModemById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'modem/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteModem(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'modem/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getModemsForSuperAdmin(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'modems-for-super-admin/',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/modem.service.ts